import { HttpClient } from '../../_http';

export function log<T>(type: 'error' | 'info' | 'warning', metadata: T): Promise<void> {
  return HttpClient.post(`logs`, { metadata: JSON.stringify(metadata), type });
}
